import React from "react";
import style from "./Preloader.module.scss";

export default function Preloader() {
  return <div className={style.wrapper}></div>;
}
